var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: "",
        value: true,
        transition: false,
        persistent: false,
      },
      on: { "click:outside": _vm.closeDialog },
    },
    [
      _c(
        "v-card",
        { staticClass: "overflow-y-hidden", attrs: { "min-height": "820px" } },
        [
          _c("v-card-title", { staticClass: "headline" }),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("MediaPreviewIMAGE", {
                        attrs: {
                          "hide-delete": "",
                          file: _vm.file,
                          "picker-mode": false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "body",
                            fn: function () {
                              return [
                                _c("v-card-subtitle", { staticClass: "pb-0" }, [
                                  _vm._v(" " + _vm._s(_vm.file.type) + " "),
                                ]),
                                _c(
                                  "v-card-text",
                                  { staticClass: "text--primary" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.file.fileName) + " "
                                    ),
                                  ]
                                ),
                                _vm.caption
                                  ? _c("v-card-text", { staticClass: "pt-5" }, [
                                      _vm._v(
                                        "Заголовок: " + _vm._s(_vm.caption)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _vm._t("actions", function () {
                return [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary darken-2" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v(" Закрыть ")]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }